import { cn } from '../../lib/cn.ts';

/**
 * What Wundo has of somebody's conversations: a memory, nothing yet while it
 * is switched on, or nothing because it is off.
 */
export type MemoryMarkState = 'memory' | 'pending' | 'off';

export interface MemoryMarkProps {
  state: MemoryMarkState;
  className?: string;
}

/**
 * The memory circle at the size of a bullet, in front of the words that say
 * the same. Solid green is a memory, a dashed outline is one on its way, and a
 * faint disc is a person Wundo is not following. Decoration: the text beside
 * it carries the meaning.
 */
export function MemoryMark({ state, className }: MemoryMarkProps) {
  return (
    <span
      data-slot='memory-mark'
      data-state={state}
      aria-hidden='true'
      className={cn(
        'inline-block size-2.5 shrink-0 rounded-full',
        state === 'memory' && 'bg-accent',
        state === 'pending' && 'border border-dashed border-ink-muted',
        state === 'off' && 'bg-line',
        className,
      )}
    />
  );
}
